module.exports = __webpack_public_path__ + "static/media/Buckinghamshire-New-University-Logo.fa561f7e.png";